<template>
  <div>
    <div class="paymentForm">
      <!-- Card number, CVV, Exp Date -->
      <div class="row">
        <!-- Card number -->
        <div class="form-group col">
          <label>Card Number *</label>
          <input type="number" v-model="cc_cardNumber" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Card number" :class="{ 'is-invalid': (errors['paymentMethod.CardNumber'] || errors['Api Error']) }" />
        </div>

        <!-- CVV -->
        <div class="form-group col-3">
          <label>CVV *</label>
          <input type="number" v-model="cc_cvv" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="CVV" :class="{ 'is-invalid': (errors['paymentMethod.Cvv'] || errors['Api Error']) }" />
        </div>

        <!-- Expiration -->
        <div class="form-group col-4">
          <label>Exp. Date *</label>
          <div class="input-group">
            <input type="number" v-model="cc_expMonth" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="MM" :class="{ 'is-invalid': (errors['paymentMethod.expirationMonth'] || errors['paymentMethod.ExpirationMonth'] || errors['Api Error']) }" min="1" max="12" />
            <input type="number" v-model="cc_expYear" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="YY" :class="{ 'is-invalid': (errors['paymentMethod.expirationYear'] || errors['paymentMethod.ExpirationYear'] || errors['Api Error']) }" min="0" max="99" />
          </div>
        </div>
      </div>

      <!-- Name, Zip Code, and add button -->
      <div class="row">
        <!-- Name -->
        <div class="form-group col">
          <label>Name on Card *</label>
          <div class="input-group">
            <input type="text" name="firstName" v-model="firstName" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="First name" />
            <input type="text" name="lastName" v-model="lastName" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Last name" :class="{ 'is-invalid': (errors['paymentMethod.LastName']) }" />
          </div>
        </div>

        <!-- ZIP -->
        <div class="form-group col-3">
          <label>Zip Code *</label>
          <input type="number" name="zip" v-model="cc_zip" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Zip Code" />
        </div>

        <!-- Add button -->
        <div class="form-group col-4">
          <button class="btn btn-sm btn-primary" style="width: 100%; margin-top: 1.4rem;" :disabled="isSubmitting" v-on:click.prevent="createCardPayment()">{{addBtnLabel}}</button>
        </div>
      </div>

      <!-- Hidden email -->
      <input type="hidden" v-model="email" />

    </div>

    <!-- Errors -->
    <div v-if="errors['Api Error']" style="margin-top: 1rem;"><strong class="text-danger">{{ errors['Api Error'] }}</strong></div>
  </div>
</template>

<script>
export default {
  props: {
    apiKey: { type: String, required: true },
    clientIp: { type: String, required: true },
    customerId: { type: Number, required: true },
    email: { type: String, default: '' },
  },
  computed: {
    addBtnLabel: function() { return (this.isSubmitting) ? 'Processing' : 'Add Card'; },
  },
  data: function() {
    return {
      cc_cardNumber: '',
      cc_expMonth: '',
      cc_expYear: '',
      cc_cvv: '',
      cc_zip: '',
      // cc_email: (this.props.email) ? this.props.email : '',
      firstName: '',
      lastName: '',

      fbCardID: false,

      isSubmitting: false,
      errorCode: false,
      errors: {},
    };
  },
  methods: {
    createCardPayment: function() {
      this.isSubmitting = true;
      this.errors = {};

      axios.post('https://payments.subscriptionplatform.com/api/paymentsv2', {
        customerID: this.customerId,
        publicApiKey: this.apiKey,
        cardNumber: this.cc_cardNumber,
        firstName: this.firstName,
        lastName: this.lastName,
        expirationMonth: this.cc_expMonth,
        expirationYear: this.cc_expYear,
        cvv: this.cc_cvv,
        email: this.email,
        clientIP: this.clientIp,
        makeDefault: true,
        recaptcha: this.$root.googleReCaptchaToken,
        postalZip: this.cc_zip,
      })
      .then(function(response) {        
        // Tell the parent to re-fetch the customer
        this.$parent.getLegalEntity();
        grecaptcha.reset();
      }.bind(this))
      .catch(function(error) {
        // Notify Bugsnag
        // Bugsnag.notify(new Error('Error submitting payment'), function(e) {
        //   e.addMetadata('response', error.response)
        // });

        if(error.response) {
          this.errorCode = error.response.data.ErrorId;

          console.warn('Error ID: ' + error.response.data.ErrorId);
          if(error.response.data.Errors) {
            error.response.data.Errors.forEach(err => {
              if(err.Value) console.warn(err.Value + ' (' + err.Key + ')');
              else console.warn(err.Key);
              this.errors[err.Key] = (err.Value) ? err.Value : true;

              // Reset the catcha
              grecaptcha.reset();
            });
          }

          // Throw an alert if we get a "Message" back
          if(error.response.data.Message) { alert(error.response.data.Message); }
        }
        else { console.error(error); }

      }.bind(this))
      .finally(function() { this.isSubmitting = false; }.bind(this));
    },
  },
}
</script>